export default {
  FETCH_PARENTS_START: 'FETCH_PARENTS_START',
  FETCH_PARENTS_SUCCESS: 'FETCH_PARENTS_SUCCESS',
  FETCH_PARENTS_FAILURE: 'FETCH_PARENTS_FAILURE',

  UPDATE_PARENTS_START: 'UPDATE_PARENTS_START',
  UPDATE_PARENTS_SUCCESS: 'UPDATE_PARENTS_SUCCESS',
  UPDATE_PARENTS_FAILURE: 'UPDATE_PARENTS_FAILURE',

  DELETE_PARENTS_START: 'DELETE_PARENTS_START',
  DELETE_PARENTS_SUCCESS: 'DELETE_PARENTS_SUCCESS',
  DELETE_PARENTS_FAILURE: 'DELETE_PARENTS_FAILURE',

  CREATE_PARENTS_START: 'CREATE_PARENTS_START',
  CREATE_PARENTS_SUCCESS: 'CREATE_PARENTS_SUCCESS',
  CREATE_PARENTS_FAILURE: 'CREATE_PARENTS_FAILURE',

  INVITE_PARENTS_START: 'INVITE_PARENTS_START',
  INVITE_PARENTS_SUCCESS: 'INVITE_PARENTS_SUCCESS',
  INVITE_PARENTS_FAILURE: 'INVITE_PARENTS_FAILURE',
}
